import React from 'react'
import { Card, CardContent, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, alpha } from '@mui/material'

const AboutBox = (props) => {
  const { about, userSubject } = props.tutor
  const theme = useTheme()

  return (
    <Card sx={{
      borderRadius: 3,
      boxShadow: `0 8px 24px ${alpha(theme.palette.common.black, 0.08)}`,
      border: `1px solid ${theme.palette.divider}`,
      overflow: 'hidden'
    }}>
      <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <Typography variant="h5" sx={{
          fontWeight: 700,
          color: theme.palette.text.primary,
          mb: 3,
          fontSize: { xs: '1.25rem', sm: '1.35rem', md: '1.5rem' },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            left: 0,
            width: 40,
            height: 3,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 2
          }
        }}>
          About the tutor
        </Typography>
        <Box
          sx={{
            color: '#1a1a1a',
            lineHeight: 1.6,
            fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem' },
            '& p': {
              margin: 0,
              marginBottom: 1.5,
              wordBreak: 'break-word',
              overflowWrap: 'break-word'
            },
            '& p:last-child': {
              marginBottom: 0
            },
            '& ul': {
              margin: 0,
              paddingLeft: { xs: 2, sm: 2.5 }
            },
            '& li': {
              marginBottom: 0.5,
              wordBreak: 'break-word',
              overflowWrap: 'break-word'
            }
          }}
          dangerouslySetInnerHTML={{ __html: about }}
        />

        {userSubject && userSubject.length > 0 && (
          <>
            <Typography variant="h5" sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              mt: 4,
              mb: 3,
              fontSize: { xs: '1.25rem', sm: '1.35rem', md: '1.5rem' },
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: 0,
                width: 40,
                height: 3,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2
              }
            }}>
              Subjects and Pricing
            </Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{
                    backgroundColor: alpha(theme.palette.common.black, 0.04),
                  }}>
                    <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem', color: theme.palette.text.secondary, py: 1.5, borderBottom: `1px solid ${theme.palette.divider}` }}>Subject</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem', color: theme.palette.text.secondary, py: 1.5, borderBottom: `1px solid ${theme.palette.divider}` }}>Level</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem', color: theme.palette.text.secondary, py: 1.5, borderBottom: `1px solid ${theme.palette.divider}` }}>Exam Board</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem', color: theme.palette.text.secondary, py: 1.5, borderBottom: `1px solid ${theme.palette.divider}` }}>Per hour</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userSubject.map((subj, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:hover': { backgroundColor: alpha(theme.palette.common.black, 0.02) },
                        '&:last-child td': { borderBottom: `1px solid ${theme.palette.divider}` },
                      }}
                    >
                      <TableCell sx={{ fontSize: '0.875rem', py: 1.5 }}>{subj.subject || ''}</TableCell>
                      <TableCell sx={{ fontSize: '0.875rem', py: 1.5 }}>{subj.level || ''}</TableCell>
                      <TableCell sx={{ fontSize: '0.875rem', py: 1.5 }}>{subj.board || 'All'}</TableCell>
                      <TableCell sx={{ fontSize: '0.875rem', py: 1.5 }}>{subj.price ? `£${subj.price}` : ''}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default AboutBox
